import getLanguageFromStorage from "syf-js-utilities/helpers/getLanguageFromStorage";
import translations from "./lang";
/**
 * This finds a string from <language>.json, then replaces its slots with values, returning a fully formatted string for the UI.
 * @param {Object} lang Object that has key of the string from <language>.json
 * @param {Object} data Values of slots to replace.  Key is slot, value is replacement.
 */
export default (function (lang, data) {
    var language = getLanguageFromStorage();
    var strings = translations[language];
    var messageKey = Object.keys(lang)[0];
    var message = strings[messageKey][lang[messageKey]];
    if (typeof message === "string" && data) {
        var result_1 = message;
        var args = Object.keys(data);
        args.forEach(function (arg) {
            result_1 = result_1.replace("%".concat(arg, "%"), data[arg]);
        });
        return result_1;
    }
    if (typeof message !== "string") {
        return message(data);
    }
    return message;
});
//# sourceMappingURL=i18n.js.map